import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/storage-hub/capture-storage/database/")({
  staticData: {
    title: "common.database",
  },
  loader: () => redirect({ to: "/storage-hub/capture-storage" }),
});
